// gameConstants.js
'use strict';

export const Game = {
  SIC_BO: 'sic-bo',
  DRAGON_TIGER_FIGHT: 'dragon-tiger-fight',
  GIFT_SLOT: 'gift-slot',
  SOARING_HIGH: 'soaring-high',
  GOLDEN_GATE: 'golden-gate',
  UGPP_SICBO: 'ugpp-sicbo',
  UGPP_CUPID_GIFT: 'ugpp-cupid-gift',
};

const STREAM_BOUND_GAME_IDS = [Game.UGPP_CUPID_GIFT];

export const UGPP_GAME_ID_PREFIX = 'ugpp-';

/**
 * Whether a game id belongs to a UGPP game. UGPP game ids are prefixed with
 * `ugpp-` (e.g. `ugpp-sicbo`), which is how they are routed to GameUgpp.
 * @param {object} params
 * @param {string} params.gameId - The game id to test.
 * @returns {boolean} True if the id is a UGPP game id.
 * @example
 * getIsUgppGame({ gameId: 'ugpp-sicbo' }); // => true
 * getIsUgppGame({ gameId: 'sic-bo' }); // => false
 */
export const getIsUgppGame = ({ gameId }) =>
  typeof gameId === 'string' && gameId.startsWith(UGPP_GAME_ID_PREFIX);

/**
 * Whether a game is bound to the livestream room it was opened from. A
 * stream-bound game sends the bound stream context with its launch token
 * request and must be force-closed once that room is no longer being watched.
 * @param {object} params
 * @param {string} params.gameId - The game id to test.
 * @returns {boolean} True if the game is bound to a livestream room.
 * @example
 * getIsStreamBoundGame({ gameId: 'ugpp-cupid-gift' }); // => true
 * getIsStreamBoundGame({ gameId: 'ugpp-sicbo' }); // => false
 */
export const getIsStreamBoundGame = ({ gameId }) =>
  STREAM_BOUND_GAME_IDS.includes(gameId);
